interface QuantityProgressProps {
  current: number
  total: number
}

export function QuantityProgress({ current, total }: QuantityProgressProps) {
  // Prevent division by zero and cap the percentage to 100%
  const raw = total > 0 ? (current / total) * 100 : 0
  const percentage = Math.min(Math.max(raw, 0), 100)

  return (
    <div
      className="flex items-center gap-2"
      style={{
        minWidth: '200px',
        width: 'fit-content',
        justifyContent: 'flex-start',
      }}
    >
      <span
        className="whitespace-nowrap text-sm"
        style={{ minWidth: '40px', textAlign: 'left', color: '#262626' }}
      >
        {current}U
      </span>
      <div className="flex-1" style={{ minWidth: '70px', maxWidth: '70px' }}>
        <div
          className="rounded-full bg-gray-200"
          style={{ height: '8px', width: '70px' }}
        >
          <div
            className="rounded-full transition-all duration-300"
            style={{
              width: `${percentage}%`,
              height: '8px',
              backgroundColor: '#1E293B',
            }}
          />
        </div>
      </div>
      <span
        className="whitespace-nowrap text-sm text-gray-500"
        style={{ minWidth: '40px', textAlign: 'left', color: '#262626' }}
      >
        {total}U
      </span>
    </div>
  )
}
